/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { Button as MuiButton, Typography } from "@mui/material";
import { spacing } from "@mui/system";
import { connect } from "react-redux";
import { loadUser } from "../../actions/AuthActions";
import Loading from "../components/Loading";

const Button = styled(MuiButton)(spacing);

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(6)};
  text-align: center;
  background: transparent;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function Page404({ auths, loadUser }) {
  const [loggedIn, setLoggedIn] = useState(false);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();
  const userType = JSON.parse(localStorage.getItem("AuthData"))?.type || null;

  useEffect(async () => {
    if (auths.token) {
      const data = await loadUser();
      if (data.type !== "SET_ALERT") {
        setLoggedIn(true);
      }
    }
    setLoader(false);
  }, []);
  if (!loader) {
    return (
      <Wrapper>
        <Helmet title="Alpha Plus" />
        {loggedIn ? (
          <Typography component="h1" variant="h1" align="center" gutterBottom>
            404
          </Typography>
        ) : (
          // navigate("/login")
          navigate("/login")
        )}
        {loggedIn ? (
          <Typography component="h2" variant="h5" align="center" gutterBottom>
            Page not found.
          </Typography>
        ) : (
          <Typography component="h2" variant="h5" align="center" gutterBottom>
            Forbidden
          </Typography>
        )}
        {loggedIn ? (
          <Typography
            component="h2"
            variant="body1"
            align="center"
            gutterBottom
          >
            You are not authorized to access this resource.
          </Typography>
        ) : (
          <Typography
            component="h2"
            variant="body1"
            align="center"
            gutterBottom
          >
            You are not authorized to access this resource.
          </Typography>
        )}

        <Button
          variant="contained"
          color="secondary"
          mt={2}
          onClick={() => {
            userType === "customer_user"
              ? navigate("/dashboard/stats")
              : navigate("/dashboard/tasks");
          }}
        >
          Return to Dashboard
        </Button>
      </Wrapper>
    );
  } else {
    return (
      <div>
        <Loading />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, { loadUser })(Page404);
